"use strict";

angular.module("core").component("versions", {
    templateUrl: require("./versions.component.html"),
    controller: function($http, MOBILE_APP_VERSION, appConfig) {
        if (MOBILE_APP_VERSION) {
            this.mobileVersion = MOBILE_APP_VERSION;
            this.visible = true;
        }
        var ctrl = this;
        $http.get("scripts/versions.json").then(function(response) {
            if (response.data) {
                ctrl.appVersion = response.data;
                ctrl.visible = true;
            }
        });
        $http.get(appConfig.API_SERVER + "/static/versions.json", {
            withCredentials: false,
            disableTokenForRequest: true
        }).then(function(response) {
            if (response.data) {
                ctrl.apiVersion = response.data;
                ctrl.visible = true;
            }
        });
    },
    bindings: {
        collapsed: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/versions/versions.component.js
// module id = 544
// module chunks = 0